'use client';

import {
	Dialog as HeadlessDialog,
	DialogBackdrop,
	DialogPanel,
	DialogTitle,
} from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { Suspense } from 'react';

import { Loader } from '@/shared';

export type DialogProps = React.PropsWithChildren<{
	open: boolean;
	onClose: (value: boolean) => void;
	title?: React.ReactNode;
	footer?: React.ReactNode;
	className?: string;
	dismissible?: boolean;
}>;

export function Dialog({
	open,
	onClose,
	title,
	className,
	footer,
	children,
	dismissible = true,
}: DialogProps) {
	const cnPanel = clsx(
		className,
		'bg-white-main relative w-full bg-white sm:max-w-[600px] sm:rounded-lg sm:rounded-t-lg sm:border sm:border-gray-4',
	);
	return (
		<HeadlessDialog
			open={open}
			onClose={dismissible ? onClose : () => {}}
			className="relative z-50"
		>
			<DialogBackdrop className="fixed inset-0 bg-gray-1/60 backdrop-blur-[1px]" />
			<div className="fixed inset-0 flex w-screen items-end justify-center sm:items-center sm:p-4">
				<DialogPanel className={cnPanel}>
					<div className="border-gray flex flex-row items-center justify-between gap-2 border-b px-4 py-6">
						{title && (
							<DialogTitle className="text-xl font-bold">{title}</DialogTitle>
						)}
						{dismissible && (
							<button
								type="button"
								aria-label="Закрыть"
								onClick={() => onClose(false)}
								className="text-gray-3 hover:text-gray-2"
							>
								<XMarkIcon className="size-6" />
							</button>
						)}
					</div>
					<Suspense
						fallback={
							<div className="flex justify-center p-12">
								<Loader size="lg" />
							</div>
						}
					>
						<div className="max-h-[80vh] overflow-y-scroll">{children}</div>
						{footer}
					</Suspense>
				</DialogPanel>
			</div>
		</HeadlessDialog>
	);
}
